import { Route, Routes } from "react-router-dom";
import "./components/stylesheets/App.css";
import { Navbar } from "./components/Navbar";
import { Home } from "./components/pages/Home";
import { About } from "./components/pages/About";
import { Services } from "./components/pages/Services";
import { Submit } from "./components/pages/Submit";
import { Success } from "./components/pages/Success";
import { Contact } from "./components/pages/Contact";
import Form from "./components/Form";
import { Footer } from "./components/Footer";

function App(){
    return (
    <>
    <head>
        <link rel="preconnect" href="https://fonts.googleapis.com"></link>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
        <link href="https://fonts.googleapis.com/css2?family=Patua+One&display=swap" rel="stylesheet"></link>
    </head>
    <Navbar/>
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/submit-form" element={<Submit />} />
        <Route path="/request/api/success" element={<Success />} />
    </Routes>
    <Footer/>
    </>
    );
}

export default App;